import { Id } from './types';

export enum Loading {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}

export interface EntriesState<T> {
  entities: Record<Id, T>;
  loading: Loading;
}

export const initialEntriesState = {
  entities: {},
  loading: Loading.IDLE,
};
